export default "__VITE_ASSET__DP$OBhhH__"